
       if (typeof window !== 'undefined') {
         function loadSvg() {
           var body = document.body;
           var svgDom = document.getElementById('__svg__icons__dom__');
           if(!svgDom) {
             svgDom = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
             svgDom.style.position = 'absolute';
             svgDom.style.width = '0';
             svgDom.style.height = '0';
             svgDom.id = '__svg__icons__dom__';
             svgDom.setAttribute('xmlns','http://www.w3.org/2000/svg');
             svgDom.setAttribute('xmlns:link','http://www.w3.org/1999/xlink');
           }
           svgDom.innerHTML = "<symbol  viewBox=\"0 0 40 40\" id=\"icon-pc\"><path d=\"M30.08 35.486h-4.36v-2.102H14.28v2.102H9.92a1.19 1.19 0 1 0 0 2.38h20.16a1.19 1.19 0 1 0 0-2.38ZM0 26.596v3.218c0 .657.533 1.19 1.19 1.19h37.62a1.19 1.19 0 0 0 1.19-1.19v-3.217H0ZM38.81 3.149H1.19A1.19 1.19 0 0 0 0 4.338v19.879h40V4.338a1.19 1.19 0 0 0-1.19-1.19Z\" /></symbol>";
           body.insertBefore(svgDom, body.lastChild);
         }
         if(document.readyState === 'loading') {
           document.addEventListener('DOMContentLoaded', loadSvg);
         } else {
           loadSvg()
         }
      }
        
export default {}